import notificationService from '@/services/NotificationService';
import { ActionTree, GetterTree, Module } from 'vuex';
import { IAppNotification } from '@/types/notifications.types';
import { IRootState } from '@/types/store.types';
import { make } from 'vuex-pathify';

const state: INotificationsState = {
    notifications: [],
    unreadCount: 0,
    loading: false
};

const actions: ActionTree<INotificationsState, IRootState> = {

    async fetchNotifications({ commit }) {
        commit('SET_LOADING', true);
        try {
            const notifications = await notificationService.getAll();
            commit('SET_NOTIFICATIONS', notifications);
            const unread = notifications.filter(n => !n.isRead).length;
            commit('SET_UNREAD_COUNT', unread);
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async fetchUnreadCount({ commit }) {
        try {
            const count = await notificationService.getUnreadCount();
            commit('SET_UNREAD_COUNT', count);
        } catch {
            // silently ignore — badge is non-critical
        }
    },

    async markRead({ commit, state: s }, id: number) {
        await notificationService.markRead(id);
        const updated = s.notifications.map(n =>
            n.id === id ? { ...n, isRead: true } : n
        );
        commit('SET_NOTIFICATIONS', updated);
        commit('SET_UNREAD_COUNT', updated.filter(n => !n.isRead).length);
    },

    async markUnread({ commit, state: s }, id: number) {
        await notificationService.markUnread(id);
        const updated = s.notifications.map(n =>
            n.id === id ? { ...n, isRead: false } : n
        );
        commit('SET_NOTIFICATIONS', updated);
        commit('SET_UNREAD_COUNT', updated.filter(n => !n.isRead).length);
    },

    async deleteNotification({ commit, state: s }, id: number) {
        await notificationService.delete(id);
        const updated = s.notifications.filter(n => n.id !== id);
        commit('SET_NOTIFICATIONS', updated);
        commit('SET_UNREAD_COUNT', updated.filter(n => !n.isRead).length);
    }

};

const getters: GetterTree<INotificationsState, any> = {};

export default {
    namespaced: true,
    state,
    mutations: make.mutations(state),
    actions,
    getters
} as Module<INotificationsState, IRootState>;

export interface INotificationsState {
    notifications: IAppNotification[];
    unreadCount: number;
    loading: boolean;
}
